import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c6bb45d")

_pushScopeId("data-v-6c6bb45d")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "text-limit" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_4 = { class: "menu-item-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_7 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      filter: false,
      filterPlaceholder: 'message.SELECT',
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onSearch: _ctx.searchHandler,
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.manufactures(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.manufacturerData,
      pagination: _ctx.pagination,
      padding: 5,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader
    }, {
      "cell-description": _withId(({row:item}) => [
        _createVNode("span", _hoisted_2, _toDisplayString(item?.description), 1)
      ]),
      "cell-actions": _withId(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_3,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_4, [
              (_ctx.$can('edit_manufacturer'))
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('delete_manufacturer'))
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
  ]))
})